import React from "react";
import EmblaCarousel from "./EmblaCarousel";
import ComradesShoot from "./ComradesShoot";
import GalaDinner from "./GalaDinner";

const Gallery = () => {
  return (
    <div className="h-full grid md:grid-cols-1 w-full">
      <div className=" grid grid-cols-1  w-full">
        <div className="   w-full object-contain">
          <div>
            <EmblaCarousel />
          </div>
        </div>

        <div className=" pt-20 w-full object-contain">
          <div>
            <ComradesShoot />
          </div>
        </div>
        <div className=" pt-20 w-full object-contain">
          <div>
            <GalaDinner />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
